module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_03b.86bab7a1.jpg";